export var Privacy;
(function (Privacy) {
    Privacy[Privacy["Show"] = 1] = "Show";
    Privacy[Privacy["Hide"] = 2] = "Hide";
})(Privacy || (Privacy = {}));
//# sourceMappingURL=matches-privacy.js.map